import { render } from "./DropdownMenu.vue?vue&type=template&id=69a652e7"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\joseph\\Desktop\\Vue Projects\\shitpost\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__